// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".\\!cursor-not-allowed[data-v-8eac12b4]{cursor:not-allowed!important}", ""]);
// Exports
module.exports = exports;
